'use strict';

var _characterMap;

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}
/* eslint-disable object-property-newline, quote-props, no-dupe-keys */
// Character map from https://github.com/django/django/blob/3c447b108ac70757001171f7a4791f493880bf5b/django/contrib/admin/static/admin/js/urlify.js


var characterMap = (_characterMap = {
  // Latin
  'À': 'A',
  'Á': 'A',
  'Â': 'A',
  'Ã': 'A',
  'Ä': 'A',
  'Å': 'A',
  'Æ': 'AE',
  'Ç': 'C',
  'È': 'E',
  'É': 'E',
  'Ê': 'E',
  'Ë': 'E',
  'Ì': 'I',
  'Í': 'I',
  'Î': 'I',
  'Ï': 'I',
  'Ð': 'D',
  'Ñ': 'N',
  'Ò': 'O',
  'Ó': 'O',
  'Ô': 'O',
  'Õ': 'O',
  'Ö': 'O',
  'Ő': 'O',
  'Ø': 'O',
  'Ù': 'U',
  'Ú': 'U',
  'Û': 'U',
  'Ü': 'U',
  'Ű': 'U',
  'Ý': 'Y',
  'Þ': 'TH',
  'Ÿ': 'Y',
  'ß': 'ss',
  'à': 'a',
  'á': 'a',
  'â': 'a',
  'ã': 'a',
  'ä': 'a',
  'å': 'a',
  'æ': 'ae',
  'ç': 'c',
  'è': 'e',
  'é': 'e',
  'ê': 'e',
  'ë': 'e',
  'ì': 'i',
  'í': 'i',
  'î': 'i',
  'ï': 'i',
  'ð': 'd',
  'ñ': 'n',
  'ò': 'o',
  'ó': 'o',
  'ô': 'o',
  'õ': 'o',
  'ö': 'o',
  'ő': 'o',
  'ø': 'o',
  'ù': 'u',
  'ú': 'u',
  'û': 'u',
  'ü': 'u',
  'ű': 'u',
  'ý': 'y',
  'þ': 'th',
  'ÿ': 'y',
  // Latin symbols
  '©': '(c)',
  // Greek
  'α': 'a',
  'β': 'b',
  'γ': 'g',
  'δ': 'd',
  'ε': 'e',
  'ζ': 'z',
  'η': 'h',
  'θ': '8',
  'ι': 'i',
  'κ': 'k',
  'λ': 'l',
  'μ': 'm',
  'ν': 'n',
  'ξ': '3',
  'ο': 'o',
  'π': 'p',
  'ρ': 'r',
  'σ': 's',
  'τ': 't',
  'υ': 'y',
  'φ': 'f',
  'χ': 'x',
  'ψ': 'ps',
  'ω': 'w',
  'ά': 'a',
  'έ': 'e',
  'ί': 'i',
  'ό': 'o',
  'ύ': 'y',
  'ή': 'h',
  'ώ': 'w',
  'ς': 's',
  'ϊ': 'i',
  'ΰ': 'y',
  'ϋ': 'y',
  'ΐ': 'i',
  'Α': 'A',
  'Β': 'B',
  'Γ': 'G',
  'Δ': 'D',
  'Ε': 'E',
  'Ζ': 'Z',
  'Η': 'H',
  'Θ': '8',
  'Ι': 'I',
  'Κ': 'K',
  'Λ': 'L',
  'Μ': 'M',
  'Ν': 'N',
  'Ξ': '3',
  'Ο': 'O',
  'Π': 'P',
  'Ρ': 'R',
  'Σ': 'S',
  'Τ': 'T',
  'Υ': 'Y',
  'Φ': 'F',
  'Χ': 'X',
  'Ψ': 'PS',
  'Ω': 'W',
  'Ά': 'A',
  'Έ': 'E',
  'Ί': 'I',
  'Ό': 'O',
  'Ύ': 'Y',
  'Ή': 'H',
  'Ώ': 'W',
  'Ϊ': 'I',
  'Ϋ': 'Y',
  // Turkish
  'ş': 's',
  'Ş': 'S',
  'ı': 'i',
  'İ': 'I'
}, _defineProperty(_characterMap, '\xE7', 'c'), _defineProperty(_characterMap, '\xC7', 'C'), _defineProperty(_characterMap, '\xFC', 'u'), _defineProperty(_characterMap, '\xDC', 'U'), _defineProperty(_characterMap, '\xF6', 'o'), _defineProperty(_characterMap, '\xD6', 'O'), _defineProperty(_characterMap, 'ğ', 'g'), _defineProperty(_characterMap, 'Ğ', 'G'), _defineProperty(_characterMap, 'ă', 'a'), _defineProperty(_characterMap, '\xEE', 'i'), _defineProperty(_characterMap, 'ș', 's'), _defineProperty(_characterMap, 'ț', 't'), _defineProperty(_characterMap, '\xE2', 'a'), _defineProperty(_characterMap, 'Ă', 'A'), _defineProperty(_characterMap, '\xCE', 'I'), _defineProperty(_characterMap, 'Ș', 'S'), _defineProperty(_characterMap, 'Ț', 'T'), _defineProperty(_characterMap, '\xC2', 'A'), _defineProperty(_characterMap, 'а', 'a'), _defineProperty(_characterMap, 'б', 'b'), _defineProperty(_characterMap, 'в', 'v'), _defineProperty(_characterMap, 'г', 'g'), _defineProperty(_characterMap, 'д', 'd'), _defineProperty(_characterMap, 'е', 'e'), _defineProperty(_characterMap, 'ё', 'yo'), _defineProperty(_characterMap, 'ж', 'zh'), _defineProperty(_characterMap, 'з', 'z'), _defineProperty(_characterMap, 'и', 'i'), _defineProperty(_characterMap, 'й', 'j'), _defineProperty(_characterMap, 'к', 'k'), _defineProperty(_characterMap, 'л', 'l'), _defineProperty(_characterMap, 'м', 'm'), _defineProperty(_characterMap, 'н', 'n'), _defineProperty(_characterMap, 'о', 'o'), _defineProperty(_characterMap, 'п', 'p'), _defineProperty(_characterMap, 'р', 'r'), _defineProperty(_characterMap, 'с', 's'), _defineProperty(_characterMap, 'т', 't'), _defineProperty(_characterMap, 'у', 'u'), _defineProperty(_characterMap, 'ф', 'f'), _defineProperty(_characterMap, 'х', 'h'), _defineProperty(_characterMap, 'ц', 'c'), _defineProperty(_characterMap, 'ч', 'ch'), _defineProperty(_characterMap, 'ш', 'sh'), _defineProperty(_characterMap, 'щ', 'sh'), _defineProperty(_characterMap, 'ъ', ''), _defineProperty(_characterMap, 'ы', 'y'), _defineProperty(_characterMap, 'ь', ''), _defineProperty(_characterMap, 'э', 'e'), _defineProperty(_characterMap, 'ю', 'yu'), _defineProperty(_characterMap, 'я', 'ya'), _defineProperty(_characterMap, 'А', 'A'), _defineProperty(_characterMap, 'Б', 'B'), _defineProperty(_characterMap, 'В', 'V'), _defineProperty(_characterMap, 'Г', 'G'), _defineProperty(_characterMap, 'Д', 'D'), _defineProperty(_characterMap, 'Е', 'E'), _defineProperty(_characterMap, 'Ё', 'Yo'), _defineProperty(_characterMap, 'Ж', 'Zh'), _defineProperty(_characterMap, 'З', 'Z'), _defineProperty(_characterMap, 'И', 'I'), _defineProperty(_characterMap, 'Й', 'J'), _defineProperty(_characterMap, 'К', 'K'), _defineProperty(_characterMap, 'Л', 'L'), _defineProperty(_characterMap, 'М', 'M'), _defineProperty(_characterMap, 'Н', 'N'), _defineProperty(_characterMap, 'О', 'O'), _defineProperty(_characterMap, 'П', 'P'), _defineProperty(_characterMap, 'Р', 'R'), _defineProperty(_characterMap, 'С', 'S'), _defineProperty(_characterMap, 'Т', 'T'), _defineProperty(_characterMap, 'У', 'U'), _defineProperty(_characterMap, 'Ф', 'F'), _defineProperty(_characterMap, 'Х', 'H'), _defineProperty(_characterMap, 'Ц', 'C'), _defineProperty(_characterMap, 'Ч', 'Ch'), _defineProperty(_characterMap, 'Ш', 'Sh'), _defineProperty(_characterMap, 'Щ', 'Sh'), _defineProperty(_characterMap, 'Ъ', ''), _defineProperty(_characterMap, 'Ы', 'Y'), _defineProperty(_characterMap, 'Ь', ''), _defineProperty(_characterMap, 'Э', 'E'), _defineProperty(_characterMap, 'Ю', 'Yu'), _defineProperty(_characterMap, 'Я', 'Ya'), _defineProperty(_characterMap, 'Є', 'Ye'), _defineProperty(_characterMap, 'І', 'I'), _defineProperty(_characterMap, 'Ї', 'Yi'), _defineProperty(_characterMap, 'Ґ', 'G'), _defineProperty(_characterMap, 'є', 'ye'), _defineProperty(_characterMap, 'і', 'i'), _defineProperty(_characterMap, 'ї', 'yi'), _defineProperty(_characterMap, 'ґ', 'g'), _defineProperty(_characterMap, 'č', 'c'), _defineProperty(_characterMap, 'ď', 'd'), _defineProperty(_characterMap, 'ě', 'e'), _defineProperty(_characterMap, 'ň', 'n'), _defineProperty(_characterMap, 'ř', 'r'), _defineProperty(_characterMap, 'š', 's'), _defineProperty(_characterMap, 'ť', 't'), _defineProperty(_characterMap, 'ů', 'u'), _defineProperty(_characterMap, 'ž', 'z'), _defineProperty(_characterMap, 'Č', 'C'), _defineProperty(_characterMap, 'Ď', 'D'), _defineProperty(_characterMap, 'Ě', 'E'), _defineProperty(_characterMap, 'Ň', 'N'), _defineProperty(_characterMap, 'Ř', 'R'), _defineProperty(_characterMap, 'Š', 'S'), _defineProperty(_characterMap, 'Ť', 'T'), _defineProperty(_characterMap, 'Ů', 'U'), _defineProperty(_characterMap, 'Ž', 'Z'), _defineProperty(_characterMap, 'ą', 'a'), _defineProperty(_characterMap, 'ć', 'c'), _defineProperty(_characterMap, 'ę', 'e'), _defineProperty(_characterMap, 'ł', 'l'), _defineProperty(_characterMap, 'ń', 'n'), _defineProperty(_characterMap, '\xF3', 'o'), _defineProperty(_characterMap, 'ś', 's'), _defineProperty(_characterMap, 'ź', 'z'), _defineProperty(_characterMap, 'ż', 'z'), _defineProperty(_characterMap, 'Ą', 'A'), _defineProperty(_characterMap, 'Ć', 'C'), _defineProperty(_characterMap, 'Ę', 'E'), _defineProperty(_characterMap, 'Ł', 'L'), _defineProperty(_characterMap, 'Ń', 'N'), _defineProperty(_characterMap, '\xD3', 'O'), _defineProperty(_characterMap, 'Ś', 'S'), _defineProperty(_characterMap, 'Ź', 'Z'), _defineProperty(_characterMap, 'Ż', 'Z'), _defineProperty(_characterMap, 'ā', 'a'), _defineProperty(_characterMap, '\u010D', 'c'), _defineProperty(_characterMap, 'ē', 'e'), _defineProperty(_characterMap, 'ģ', 'g'), _defineProperty(_characterMap, 'ī', 'i'), _defineProperty(_characterMap, 'ķ', 'k'), _defineProperty(_characterMap, 'ļ', 'l'), _defineProperty(_characterMap, 'ņ', 'n'), _defineProperty(_characterMap, '\u0161', 's'), _defineProperty(_characterMap, 'ū', 'u'), _defineProperty(_characterMap, '\u017E', 'z'), _defineProperty(_characterMap, 'Ā', 'A'), _defineProperty(_characterMap, '\u010C', 'C'), _defineProperty(_characterMap, 'Ē', 'E'), _defineProperty(_characterMap, 'Ģ', 'G'), _defineProperty(_characterMap, 'Ī', 'I'), _defineProperty(_characterMap, 'Ķ', 'K'), _defineProperty(_characterMap, 'Ļ', 'L'), _defineProperty(_characterMap, 'Ņ', 'N'), _defineProperty(_characterMap, '\u0160', 'S'), _defineProperty(_characterMap, 'Ū', 'U'), _defineProperty(_characterMap, '\u017D', 'Z'), _defineProperty(_characterMap, 'أ', 'a'), _defineProperty(_characterMap, 'ب', 'b'), _defineProperty(_characterMap, 'ت', 't'), _defineProperty(_characterMap, 'ث', 'th'), _defineProperty(_characterMap, 'ج', 'g'), _defineProperty(_characterMap, 'ح', 'h'), _defineProperty(_characterMap, 'خ', 'kh'), _defineProperty(_characterMap, 'د', 'd'), _defineProperty(_characterMap, 'ذ', 'th'), _defineProperty(_characterMap, 'ر', 'r'), _defineProperty(_characterMap, 'ز', 'z'), _defineProperty(_characterMap, 'س', 's'), _defineProperty(_characterMap, 'ش', 'sh'), _defineProperty(_characterMap, 'ص', 's'), _defineProperty(_characterMap, 'ض', 'd'), _defineProperty(_characterMap, 'ط', 't'), _defineProperty(_characterMap, 'ظ', 'th'), _defineProperty(_characterMap, 'ع', 'aa'), _defineProperty(_characterMap, 'غ', 'gh'), _defineProperty(_characterMap, 'ف', 'f'), _defineProperty(_characterMap, 'ق', 'k'), _defineProperty(_characterMap, 'ك', 'k'), _defineProperty(_characterMap, 'ل', 'l'), _defineProperty(_characterMap, 'م', 'm'), _defineProperty(_characterMap, 'ن', 'n'), _defineProperty(_characterMap, 'ه', 'h'), _defineProperty(_characterMap, 'و', 'o'), _defineProperty(_characterMap, 'ي', 'y'), _defineProperty(_characterMap, '\u0105', 'a'), _defineProperty(_characterMap, '\u010D', 'c'), _defineProperty(_characterMap, '\u0119', 'e'), _defineProperty(_characterMap, 'ė', 'e'), _defineProperty(_characterMap, 'į', 'i'), _defineProperty(_characterMap, '\u0161', 's'), _defineProperty(_characterMap, 'ų', 'u'), _defineProperty(_characterMap, '\u016B', 'u'), _defineProperty(_characterMap, '\u017E', 'z'), _defineProperty(_characterMap, '\u0104', 'A'), _defineProperty(_characterMap, '\u010C', 'C'), _defineProperty(_characterMap, '\u0118', 'E'), _defineProperty(_characterMap, 'Ė', 'E'), _defineProperty(_characterMap, 'Į', 'I'), _defineProperty(_characterMap, '\u0160', 'S'), _defineProperty(_characterMap, 'Ų', 'U'), _defineProperty(_characterMap, '\u016A', 'U'), _defineProperty(_characterMap, '\u017D', 'Z'), _defineProperty(_characterMap, 'ђ', 'dj'), _defineProperty(_characterMap, 'ј', 'j'), _defineProperty(_characterMap, 'љ', 'lj'), _defineProperty(_characterMap, 'њ', 'nj'), _defineProperty(_characterMap, 'ћ', 'c'), _defineProperty(_characterMap, 'џ', 'dz'), _defineProperty(_characterMap, 'đ', 'dj'), _defineProperty(_characterMap, 'Ђ', 'Dj'), _defineProperty(_characterMap, 'Ј', 'j'), _defineProperty(_characterMap, 'Љ', 'Lj'), _defineProperty(_characterMap, 'Њ', 'Nj'), _defineProperty(_characterMap, 'Ћ', 'C'), _defineProperty(_characterMap, 'Џ', 'Dz'), _defineProperty(_characterMap, 'Đ', 'Dj'), _defineProperty(_characterMap, '\xE7', 'c'), _defineProperty(_characterMap, 'ə', 'e'), _defineProperty(_characterMap, '\u011F', 'g'), _defineProperty(_characterMap, '\u0131', 'i'), _defineProperty(_characterMap, '\xF6', 'o'), _defineProperty(_characterMap, '\u015F', 's'), _defineProperty(_characterMap, '\xFC', 'u'), _defineProperty(_characterMap, '\xC7', 'C'), _defineProperty(_characterMap, 'Ə', 'E'), _defineProperty(_characterMap, '\u011E', 'G'), _defineProperty(_characterMap, '\u0130', 'I'), _defineProperty(_characterMap, '\xD6', 'O'), _defineProperty(_characterMap, '\u015E', 'S'), _defineProperty(_characterMap, '\xDC', 'U'), _defineProperty(_characterMap, 'ა', 'a'), _defineProperty(_characterMap, 'ბ', 'b'), _defineProperty(_characterMap, 'გ', 'g'), _defineProperty(_characterMap, 'დ', 'd'), _defineProperty(_characterMap, 'ე', 'e'), _defineProperty(_characterMap, 'ვ', 'v'), _defineProperty(_characterMap, 'ზ', 'z'), _defineProperty(_characterMap, 'თ', 't'), _defineProperty(_characterMap, 'ი', 'i'), _defineProperty(_characterMap, 'კ', 'k'), _defineProperty(_characterMap, 'ლ', 'l'), _defineProperty(_characterMap, 'მ', 'm'), _defineProperty(_characterMap, 'ნ', 'n'), _defineProperty(_characterMap, 'ო', 'o'), _defineProperty(_characterMap, 'პ', 'p'), _defineProperty(_characterMap, 'ჟ', 'j'), _defineProperty(_characterMap, 'რ', 'r'), _defineProperty(_characterMap, 'ს', 's'), _defineProperty(_characterMap, 'ტ', 't'), _defineProperty(_characterMap, 'უ', 'u'), _defineProperty(_characterMap, 'ფ', 'f'), _defineProperty(_characterMap, 'ქ', 'q'), _defineProperty(_characterMap, 'ღ', 'g'), _defineProperty(_characterMap, 'ყ', 'y'), _defineProperty(_characterMap, 'შ', 'sh'), _defineProperty(_characterMap, 'ჩ', 'ch'), _defineProperty(_characterMap, 'ც', 'c'), _defineProperty(_characterMap, 'ძ', 'dz'), _defineProperty(_characterMap, 'წ', 'w'), _defineProperty(_characterMap, 'ჭ', 'ch'), _defineProperty(_characterMap, 'ხ', 'x'), _defineProperty(_characterMap, 'ჯ', 'j'), _defineProperty(_characterMap, 'ჰ', 'h'), _characterMap);
/* eslint-enable object-property-newline, quote-props, no-dupe-keys */

var defaultOptions = {
  separator: '-',
  preserveCase: false
}; // Function from https://developer.mozilla.org/en/docs/Web/JavaScript/Guide/Regular_Expressions#Using_special_characters

function escapeRegExp(str) {
  return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // $& means the whole matched string
}

function transliterate(str) {
  return str.split('').map(function (c) {
    return characterMap[c] || c;
  }).join('');
}

function parameterize(str, options) {
  var opts = Object.assign({}, defaultOptions, options); // Replaces non-ASCII characters with an ASCII approximation

  var output = transliterate(str); // Convert unwanted chars into the separator

  output = output.replace(/[^a-z0-9-_]/gi, opts.separator || '');

  if (opts.separator) {
    var escapedSep = escapeRegExp(String(opts.separator));
    var maxOneSepRegExp = new RegExp(escapedSep + '{2,}', 'g');
    var trimSepRegExp = new RegExp('^' + escapedSep + '|' + escapedSep + '$', 'g'); // No more than one of the separator in a row.

    output = output.replace(maxOneSepRegExp, opts.separator); // Remove leading/trailing separator.

    output = output.replace(trimSepRegExp, '');
  }

  if (!opts.preserveCase) {
    output = output.toLowerCase();
  }

  return output;
}

module.exports = parameterize;